import { useContent } from "contexts/contentContext/contentContext";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const ALLOWED_PAGES = ["user/"];

type HandleNavigateArgsT = {
  page?: string;
  fullUrl?: string;
  event: React.MouseEvent<HTMLAnchorElement, MouseEvent>;
};

const useNavigateWithoutPageReload = () => {
  const { getPath } = useContent();
  const navigate = useNavigate();

  const currentPageUserRef = useRef<boolean | null>(null);

  useEffect(() => {
    currentPageUserRef.current = window.location.href.includes("user/");
  }, []);

  const handleNavigate = ({ page, fullUrl, event }: HandleNavigateArgsT) => {
    if (
      currentPageUserRef.current &&
      ((page &&
        ALLOWED_PAGES.some((allowedPage) => page.includes(allowedPage))) ||
        (fullUrl &&
          ALLOWED_PAGES.some((allowedPage) => fullUrl.includes(allowedPage))))
    ) {
      // prevent default behavior for links
      event.preventDefault();

      if (page) {
        navigate(`${getPath()}${page}`);
      } else if (fullUrl) {
        // get path from url
        const url = new URL(fullUrl);
        const path = url.pathname;
        navigate(path);
      }
    }
  };

  return handleNavigate;
};

export default useNavigateWithoutPageReload;
